"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip as TooltipPrimitive } from "@base-ui/react/tooltip";
import { cn } from "cn";
function TooltipProvider(t0) {
  const $ = _c(10);
  let children;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      delay: t1,
      closeDelay: t2,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const delay = t1 === undefined ? 200 : t1;
  const closeDelay = t2 === undefined ? 300 : t2;
  let t3;
  if ($[5] !== children || $[6] !== closeDelay || $[7] !== delay || $[8] !== props) {
    t3 = <TooltipPrimitive.Provider closeDelay={closeDelay} data-slot="tooltip-provider" delay={delay} {...props}>{children}</TooltipPrimitive.Provider>;
    $[5] = children;
    $[6] = closeDelay;
    $[7] = delay;
    $[8] = props;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
function TooltipContent(t0) {
  const $ = _c(14);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      sideOffset: t1,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const sideOffset = t1 === undefined ? 0 : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("z-(--z-tooltip) w-fit text-balance rounded-lg bg-surface px-2 py-1.5 text-fg text-sm shadow-ring", "origin-(--transform-origin) transition-[scale,opacity] duration-120 ease-out data-instant:transition-none data-ending-style:scale-95 data-starting-style:scale-95 data-ending-style:opacity-0 data-starting-style:opacity-0 motion-reduce:transition-none", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== props || $[9] !== t2) {
    t3 = <TooltipPrimitive.Popup className={t2} data-slot="tooltip-content" {...props}>{children}</TooltipPrimitive.Popup>;
    $[7] = children;
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== sideOffset || $[12] !== t3) {
    t4 = <TooltipPrimitive.Portal keepMounted={true}><TooltipPrimitive.Positioner sideOffset={sideOffset}>{t3}</TooltipPrimitive.Positioner></TooltipPrimitive.Portal>;
    $[11] = sideOffset;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };